import { FileActionButton } from "../file-action/file-action-controls";
 
import React, { useState, useEffect, Suspense, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { complaintmodel } from '../../models/complaints/complaint-model';
import { Toast } from "primereact/toast";
import { complaintExport } from '../Complaint/complaint-list-export';
import ComplaintService from '../../services/complaint/ComplaintService';
import AppLoading from '../app-loading/app-loading';
import ComplaintSearch from './Complaint-Search';
import ViewallComplaintsDatatable from './View-All-Complaints-datatable';
 
const Typedetails: React.FC = () => {
  const toast = useRef<Toast>(null);
  const { t } = useTranslation();
  const [complainttype, setComplaintType] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const [filteredComplaints, setFilteredComplaints] = useState<complaintmodel[]>([]);
  const [complaintList, setComplaintList] = useState<complaintmodel[]>([]);
  const [updatedData, setUpdatedData] = useState<complaintmodel[]>([]);
  const [pageNo, setPageNo] = useState(1);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [pageSize, setPageSize] = useState(10);
 
 
  const getDefaultDateRange = () => {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
   
    return {
      startDate: yesterday.toISOString().split('T')[0],
      endDate: today.toISOString().split('T')[0]
    };
  };
 
  // Initialize filters with default date range
  const [filters, setFilters] = useState<any>({
    dateRange: getDefaultDateRange()
  });
 
  useEffect(() => {
    const loadComplaints = async () => {
      setLoading(true);
      try {
        const response = await fetchComplaints(pageNo, pageSize, filters);
        setComplaintList(response.data);
        setFilteredComplaints(response.data);
        setTotalRecords(response.totalRecords);
      } catch (error) {
        console.error('Error loading complaints:', error);
        setComplaintList([]);
        setFilteredComplaints([]);
        setTotalRecords(0);
      } finally {
       setLoading(false);
      }
    };
 
    loadComplaints();
  }, [pageNo, pageSize, filters]);
 
  const fetchComplaints = async (page: number, size: number, filters: any = {}) => {
    try {
      const hasFilters = Object.values(filters).some(val => {
        if (Array.isArray(val)) {
          return val.length > 0;
        }
        return val !== null && val !== undefined && val !== '';
      });
 
      const params = {
        pageNumber: page,
        pageSize: size,
        ...(filters.dateRange && {
          startDate: filters.dateRange.startDate,
          endDate: filters.dateRange.endDate
        }),
        // Include other filters if needed
        ...filters
      };
 
      const response = hasFilters
        ? await ComplaintService.getfilteredComplaints(params)
        : await ComplaintService.getfilteredComplaints(params);
       
      return {
        data: response.complaints,
        totalRecords: response.totalRecords,
      };
    } catch (error) {
      console.error('Error fetching complaints:', error);
      return {
        data: [],
        totalRecords: 0,
      };
    }
  };
 
  const handleSearch = (filters: any) => {
    setPageNo(1); // Reset to first page when new filters are applied
    setFilters(filters);
  };
 
  const handlePageChange = async (event: any) => {
    const newPageNumber = Math.floor(event.first / event.rows) + 1;
    setPageNo(newPageNumber);
    setPageSize(event.rows);
  };
 
  const hadelNewDate = (params: any) => {
    setUpdatedData(params);
    setFilteredComplaints(prev => [...prev, params]);
  };
 
  const handelComplaintList = (params: complaintmodel[]) => {
    setComplaintList(params);
    setFilteredComplaints(params);
  };
 
  return (
    <>
      <Suspense fallback={<AppLoading />}>
        <Toast ref={toast} position="top-center" />
        <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
          <div className="col-12">
            <div className="flex align-items-center justify-content-between flex-wrap gap-2 w-full card-container mb-0">
              <h5 className="ml-1 mb-0">{t("View All Complaints")}</h5>
              <span>
                <FileActionButton action="export"
                  className="text-black border-round mr-2"
                  onClick={e =>
                    complaintExport(filteredComplaints.length > 0 ? filteredComplaints : complaintList)
                  }
                  icon="pi pi-file-export mr-1"
                  text
                  raised
                >
                  Export Complaints
                </FileActionButton>
              </span>
              <ComplaintSearch
                setComplaintTypes={setComplaintType}
                onSearch={handleSearch}
                setLoading={setLoading}
                setNewData={hadelNewDate}
                initialDates={filters.dateRange}
              />
            </div>
          </div>
          <ViewallComplaintsDatatable
            data={filteredComplaints}
            updatedData={updatedData}
            complaintList={handelComplaintList}
            pageNo={pageNo}
            pageSize={pageSize}
            handlepagechange={handlePageChange}
            totalRecordsCount={totalRecords}
          />
        </div>
         {loading && <AppLoading />}
      </Suspense>
    </>
  );
};
 
export default Typedetails;
 
 
 